module.exports = __webpack_public_path__ + "static/img/img_gas.c3a3b31.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/site/img_gas.jpg
// module id = Y+KP
// module chunks = 0